import { PaletteConfigProvider } from 'palette/Config';
import CarouselSectionMobile from '../components/CarouselSectionMobile';

function CarouselSectionDesktopSSR(props) {
    return (
        <PaletteConfigProvider
            device="desktop"
            svgPath={App.Config.svgUrl}
            theme="booztlet"
        >
            <CarouselSectionMobile {...props} />
        </PaletteConfigProvider>
    );
}

export default CarouselSectionDesktopSSR;
